//src/theme/palette.ts
const colors = {
  // Brand colors
  primary: '#0056b3',
  secondary: '#D49A67',
  background: '#F7F2EC',
  bodyBackground: '#EAECEE',
  text: '#212529',
  lightText: '#ffffff',
  highlight: '#FFC107',
  disabled: '#BBBBBB',
  success: '#218838',
  danger: '#C82333',
  warning: '#E0A800',
  info: '#138496',
  iconColor: '#212529',

  // Link colors
  linkColor: '#0056b3',
  linkHover: '#003f75',
  primaryHover: '#003f75',

  // Button colors
  newButtonColor: '#41591a',
  newButtonHover: '#1f2a0e',
  newButtonActive002: '#9C6B4B',
  newButtonActiveHover: '#714929',
  buttonTextColor: '#ffffff',

  //Header colors
  sealBrown: '#442410ff',
  cafNoir: '#3a2519',
  russet: '#6D4F28',
  bistre: '#2F2115ff',

  // Footer colors
  footerLink: '#004085',
  footerLinkHover: '#002952',

  // ADA-compliant button colors
  buttonBackground: '#794722',
  buttonBackgroundHover: '#5A3520',
};

export default colors;
